import {
  columnSelector,
} from './columnSelector';
import { escapeHTML } from '../../../util/util';

/**
 * Helper function for setting multiple attributes
 * @param {Node} element [dom element to set attributes on]
 * @param {object} options [attributes to set key is attribute name]
 */
export function setAttributes(element, options) {
  Object.keys(options).forEach((option) => {
    element.setAttribute(option, options[option]);
  });
  return element;
}

/**
 * Native JS version of $.toggleClass
 * shamelessy borrowed from youmightnotneedjquery.com
 * @param  {node}   node      [element to toggle class on]
 * @param  {string} className [class to toggle]
 */
export function toggleClass(node, className) {
  if (node.classList) {
    node.classList.toggle(className);
    return;
  }
  const classes = node.className.split(' ');
  const existingIdx = classes.indexOf(className);

  if (existingIdx >= 0) {
    classes.splice(existingIdx, 1);
  } else {
    classes.push(className);
  }

  node.className = classes.join(' ');
}

/**
 * Convert a map to an array (using Object.keys(map).map(mapToArray(map)))
 * @param  {object} map [map to convert to array]
 * @return {function}   [function which maps over]
 */
export function mapToArray(map) {
  return (key) => Object.assign({}, map[key], { key });
}

/**
 * Map object to column selector (with keyed events)
 * @param {function} events     [events to map into object]
 * @param {string}   key        [key for the column selector]
 * @param {string}   label      [label for the column selector]
 * @param {string}   parentSlug [slug of the parents]
 * @param {bool}     isSelected [if column selector should be selected on pageload]
 * @return {node}               [columnSelector node]
 */
export function mapEventsToColumnSelector(
  events,
  key,
  label,
  parentSlug,
  isSelected = false
) {
  return columnSelector({
    key,
    parentSlug,
    label,
    isSelected,
    events: events(key, parentSlug),
  });
}

/**
 * Build the parent dropdown for nested
 * @param  {string} text    [parent name]
 * @param  {number} depth   [current depth of the parent]
 * @param {function} events [events to map into object]
 * @return {node}           [dom object]
 */
export function buildParent(text, depth, { clearAll }, active = false) {
  const wrapper = document.createElement('dt');
  const label = document.createElement('span');
  const btn = document.createElement('span');

  label.setAttribute('class', 'accordion-title serif');
  label.innerHTML = `${escapeHTML(text)}`;
  wrapper.appendChild(label);

  btn.setAttribute('class', `plus-btn-tan ${active ? 'active' : ''}`);

  btn.addEventListener('click', (evt) => {
    evt.preventDefault;
    toggleClass(btn, 'active');
    toggleClass(
      wrapper.parentNode.querySelector('.check-boxes-dropdown-scroller'),
      'ng-hide'
    );
  });

  wrapper.appendChild(btn);

  // Only display on first children
  if (depth === 0 && clearAll) {
    const clear = document.createElement('span');
    clear.setAttribute('class', 'clear-selections');
    clear.innerHTML = dcStrings.clearAllSelections;
    clear.addEventListener('click', clearAll);
    wrapper.appendChild(clear);
  }

  return wrapper;
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/directives/refineColumns/children/util.js